import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_VERSION_SUBMODULES_COLUMN_ID } from "../constants";
import { ModuleVersionSubmoduleRow } from "../types";
import ModuleVersionSubmodulesTableInstructionsCell from "./InstructionsCell";
import ModuleVersionSubmodulesTableNameCell from "./NameCell";

export const MODULE_VERSION_SUBMODULES_TABLE_CELLS: Record<
  MODULE_VERSION_SUBMODULES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionSubmoduleRow>) => JSX.Element
> = {
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.NAME]: ModuleVersionSubmodulesTableNameCell,
  [MODULE_VERSION_SUBMODULES_COLUMN_ID.INSTRUCTIONS]: ModuleVersionSubmodulesTableInstructionsCell,
};
